/**
 * Dealer Directory page copy (Dealer Directory M3–M5).
 */
import { PUBLIC_DEALER_DIRECTORY_PATH, PUBLIC_SEARCH_PATH } from "../seo/seoConstants";

export const DEALER_DIRECTORY_PAGE_COPY_ES = {
  eyebrow: "AutoMapa",
  title: "Concesionarios de carros usados en Medellín",
  intro:
    "Explora concesionarios en AutoMapa, revisa su inventario disponible y consulta señales básicas de confianza antes de contactar.",
  trustNote:
    "AutoMapa organiza información de concesionarios y vehículos para ayudarte a comparar opciones. Antes de comprar, confirma disponibilidad, precio, documentos y estado del vehículo directamente con el vendedor.",
  searchCta: "Ver carros usados",
  exploreDealersCta: "Explorar concesionarios",
  profileCta: "Ver perfil",
  loading: "Cargando concesionarios…",
  emptyTitle: "No hay concesionarios disponibles por ahora.",
  emptyBody: "Puedes seguir explorando vehículos usados publicados en AutoMapa.",
  errorTitle: "No pudimos cargar los concesionarios.",
  errorBody: "Intenta nuevamente o vuelve a la búsqueda de carros usados.",
  retry: "Intentar nuevamente",
  resultMany: (count) => `${count} concesionarios disponibles`,
  resultOne: "1 concesionario disponible",
  resultGeneric: "Concesionarios disponibles",
  resultFilteredMany: (count) => `${count} concesionarios con estos filtros`,
  resultFilteredOne: "1 concesionario con estos filtros",
  filteredEmptyTitle: "No encontramos concesionarios con estos filtros.",
  filteredEmptyBody:
    "Prueba quitando algunos filtros o vuelve a ver todos los concesionarios disponibles.",
  clearFilters: "Limpiar filtros",
  statDealers: (count) => `${count} concesionarios`,
  statVerified: (count) => `${count} verificados`,
  statInventory: (count) => `${count} con inventario disponible`,
  contentHeading: "Concesionarios disponibles",
  contentSubheading:
    "Selecciona un concesionario para ver su perfil e inventario publicado en AutoMapa.",
  mapTitle: "Mapa de concesionarios",
  viewModeLabel: "Vista",
  viewModeList: "Lista",
  viewModeSplit: "Dividida",
  viewModeMap: "Mapa",
  mapScopeHint: "El mapa muestra los concesionarios visibles con estos filtros.",
  trustBlockHeading: "Antes de contactar un concesionario",
  trustBlockChecklistCta: "Ver checklist de compra",
  trustAlertDismissAria: "Cerrar aviso de seguridad",
};

export const DEALER_DIRECTORY_TRUST_CHECKLIST_ITEMS_ES = [
  "Confirmar disponibilidad del vehículo",
  "Confirmar precio y condiciones",
  "Revisar SOAT, tecnomecánica y documentos",
  "Considerar un peritaje independiente",
  "Evitar pagos sin verificar datos y condiciones",
];

export const DEALER_DIRECTORY_BREADCRUMBS_ES = [
  { label: "Inicio", href: "/" },
  { label: "Carros usados", href: PUBLIC_SEARCH_PATH },
  { label: "Concesionarios", href: PUBLIC_DEALER_DIRECTORY_PATH },
];

export const DEALER_DIRECTORY_LIST_SECTION_ID = "concesionarios";

/** @deprecated Prefer `getDealerDirectoryMetadata` (Dealer Directory M10). */
export const DEALER_DIRECTORY_PAGE_SEO = {
  title: "Concesionarios de carros usados en Medellín | AutoMapa",
  description:
    "Encuentra concesionarios de carros usados en Medellín. Consulta perfiles públicos, inventario disponible y señales básicas de confianza en AutoMapa.",
  canonicalPath: "/v/automap/concesionarios",
};

export const DEALER_DIRECTORY_PAGE_STATUS = {
  SUCCESS: "success",
  EMPTY: "empty",
  ERROR: "error",
  PARTIAL: "partial",
};
